import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Cases', path: '/cases' },
  { label: 'Services', path: '/services' },
  { label: 'Contact', path: '/contact' },
];

export default function NeutraNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const isDark = isHome && !scrolled;

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-300"
      style={{
        background: scrolled ? 'rgba(255,255,255,0.97)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(0,0,0,0.08)' : 'none',
      }}
    >
      <div className="px-6 md:px-12 lg:px-16 py-5 flex items-center justify-between max-w-[1440px] mx-auto">
        {/* Logo */}
        <Link
          to="/"
          className="flex items-center gap-2 cursor-pointer"
        >
          <span
            className="text-sm font-bold tracking-tight"
            style={{
              fontFamily: '\'DM Sans\', sans-serif',
              color: isDark ? '#ffffff' : '#111111',
              letterSpacing: '-0.01em',
            }}
          >
            NOVA AI DIGITAL LLC
          </span>
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map(({ label, path }) => {
            const active = location.pathname === path;
            return (
              <Link
                key={path}
                to={path}
                className="relative px-4 py-2 text-sm transition-all duration-200 cursor-pointer whitespace-nowrap rounded-full"
                style={{
                  fontFamily: '\'DM Sans\', sans-serif',
                  fontWeight: active ? 600 : 400,
                  color: isDark
                    ? active ? '#ffffff' : 'rgba(255,255,255,0.6)'
                    : active ? '#111111' : 'rgba(0,0,0,0.5)',
                }}
              >
                {active && (
                  <span
                    className="absolute left-2 top-1/2 -translate-y-1/2 flex gap-0.5"
                  >
                    <span className="w-1 h-1 rounded-full" style={{ background: isDark ? '#fff' : '#111' }} />
                    <span className="w-1 h-1 rounded-full" style={{ background: isDark ? '#fff' : '#111' }} />
                  </span>
                )}
                <span className={active ? 'pl-3' : ''}>{label}</span>
              </Link>
            );
          })}
        </nav>



        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 cursor-pointer p-1"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span
            className="block w-5 h-px transition-all duration-300"
            style={{
              background: isDark ? '#fff' : '#111',
              transform: menuOpen ? 'rotate(45deg) translate(2px, 4px)' : 'none',
            }}
          />
          <span
            className="block w-5 h-px transition-all duration-300"
            style={{
              background: isDark ? '#fff' : '#111',
              opacity: menuOpen ? 0 : 1,
            }}
          />
          <span
            className="block w-5 h-px transition-all duration-300"
            style={{
              background: isDark ? '#fff' : '#111',
              transform: menuOpen ? 'rotate(-45deg) translate(2px, -4px)' : 'none',
            }}
          />
        </button>
      </div>

      {/* Mobile menu */}
      <div
        className="md:hidden overflow-hidden transition-all duration-300 bg-white border-t border-black/8"
        style={{ maxHeight: menuOpen ? '400px' : '0' }}
      >
        <div className="px-6 py-6 flex flex-col gap-0">
          {navLinks.map(({ label, path }) => (
            <Link
              key={path}
              to={path}
              className="py-4 border-b border-black/8 text-sm text-black cursor-pointer"
              style={{ fontFamily: '\'DM Sans\', sans-serif' }}
            >
              {label}
            </Link>
          ))}

        </div>
      </div>
    </header>
  );
}
